import styled from 'styled-components';
import HappySearchIcon from '@stencil/icons/src/HappySearchIcon/HappySearchIcon';

import {
  CenteredDivWrap,
  CenteredSpaceWrap,
  BaseColumnWrap,
  SmallSectionHeader,
  ButtonBase,
} from '../../../CommonStyleUtils/dwebCommon.styles';

export const AutoSuggestOuterWrap = styled.div(
  props => `
    width: 50%;
    padding-right: ${props.theme.spacing.base};
    z-index: ${props.theme.misc.zIndex.large};
  `,
);

export const AutoSuggestInnerWrap = styled.div(
  props => `
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    padding: ${props.theme.spacing.xxlarge};
    box-shadow: 0 0.2rem 1.2rem 0 ${props.theme.colors.shadow.light};
    position: relative;
    z-index: ${props.theme.misc.zIndex.large};
  `,
);

export const SearchIconWrap = styled(HappySearchIcon)(
  props => `

  width:1.6rem;
  height:1.6rem;
  margin-top:${props.theme.spacing.small};
  margin-right:${props.theme.spacing.small};
  fill:${props.theme.colors.downriver.medium};
`,
);

export const HotelTypeSelectWrap = styled.div(
  props => `
    display: flex;
    padding-bottom: ${props.theme.spacing.xxlarge};
  `,
);

export const RadioButtonWrap = styled.div(
  props => `
    display: flex;
    position: relative;
    margin-right: ${props.theme.spacing.xxlarge}
  `,
);

export const RadioText = styled(SmallSectionHeader)(
  props => `
    color: ${props.theme.colors.downriver.medium};
  `,
);

export const RadioButtonLabel = styled.label(
  props => `
    position: absolute;
    top: 0;
    left: 0;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: ${props.theme.misc.borderRadius.round};
    background: ${props.theme.colors.goWhite.base};
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.downriver.medium};
  `,
);

export const RadioButton = styled.input(
  props => `
    opacity: 0;
    z-index: 1;
    border-radius: ${props.theme.misc.borderRadius.round};
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.downriver.base};
    width: 1.6rem;
    height: 1.6rem;
    margin-right: ${props.theme.spacing.small};
    cursor: pointer;
    &:hover ~ ${RadioButtonLabel} {
      background: ${props.theme.colors.goWhite.base};
      &::after {
        content: "";
        display: block;
        border-radius: ${props.theme.misc.borderRadius.round};
        width: 1rem;
        height: 1rem;
        margin: ${props.theme.spacing.xsmall};
        background: ${props.theme.colors.goBrandBlue.base};
      }
    }
    &:checked + ${RadioButtonLabel} {
      background: ${props.theme.colors.goWhite.base};
      color: ${props.theme.colors.goBrandBlue.base}
      border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.base};
      &::after {
        content: '';
        display: block;
        border-radius: ${props.theme.misc.borderRadius.round};
        width: 1rem;
        height: 1rem;
        margin: ${props.theme.spacing.xsmall};
        background: ${props.theme.colors.goBrandBlue.base};
      }
    }
    &:checked ~ ${RadioText} {
      color: ${props.theme.colors.goBrandBlue.base}
    }
  `,
);

export const CitySearchWrap = styled.div(
  props => `
    margin-bottom: ${props.theme.spacing.large};
    &:last-child{
      margin-bottom: ${props.theme.spacing.custom(50)};
    }
  `,
);

export const PaxCountWrap = styled.div(
  props => `
    margin-bottom: ${props.theme.spacing.custom(50)};
  `,
);

export const AutoSuggestLabelText = styled.span(
  props => `
    font-size: ${props.theme.font.custom(16)};
    color: ${props.theme.colors.downriver.medium};
  `,
);

export const SearchInputWrap = styled.div`
  display: flex;
  width: 100%;
  padding: ${props => props.theme.spacing.base} 0 ${props => props.theme.spacing.large} 0;
  position: relative;
  cursor: pointer;
  align-items: center;
  border-bottom: ${props =>
    props.isactive === 'true'
      ? `0.3rem solid ${props.theme.colors.goBrandBlue.base}`
      : `${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium}`};
`;

export const CitySearchInput = styled.input(
  props => `
    width:90%;
    border: none;
    height:2.5rem;
    font-size: ${props.theme.font.large};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    

    ::placeholder {
      color: ${props.theme.colors.downriver.medium};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large};
      font-family: ${props.theme.font.fontFamily};
      font-weight: bold;
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const SearchButtonAutoSuggest = styled(ButtonBase)(
  props => `
    font-size: ${props.theme.font.custom(22)};
    border-radius: ${props.theme.misc.borderRadius.custom(30)};
    box-shadow: 0 0.2rem 1.2rem 0 ${props.theme.colors.shadow.light};
    position: absolute;
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
    height: 6rem;
    width: 27rem;
  `,
);

export const CheckInDateWrapDiv = styled(SmallSectionHeader)(
  props => `
  height:2.5rem;
  margin-right: ${props.theme.spacing.base};
  cursor:pointer;

  `,
);

export const NightCountWrap = styled(CenteredDivWrap)(
  props => `
    background-color: ${props.theme.colors.goBrandBlue.light}; 
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    padding:  ${props.theme.spacing.custom(3)}  ${props.theme.spacing.custom(9)};
    margin-right: ${props.theme.spacing.custom(30)};
    height:2.5rem;
    width: 8rem;
    &::after {
      border-width:10px;
    }
  `,
);

export const SearchCheckingDateWrap = styled(CenteredSpaceWrap)(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    padding-bottom: ${props.theme.spacing.large};
    padding-top: ${props.theme.spacing.base};
    position:relative;
  `,
);

export const PageOverlay = styled.div(
  props => `
    display: flex;
    width:100%;
    background-
    opacity:0.4;
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${props.theme.misc.zIndex.base};
  `,
);

export const CheckInCheckOutWrap = styled.div(
  props => `
    width:42%;
  `,
);

export const AutoSuggestCheckText = styled.div(
  props => `
  font-size: ${props.theme.font.custom(16)};
  color: ${props.theme.colors.downriver.medium};
  margin-bottom: ${props.theme.spacing.base};
  `,
);

export const VerticalLine = styled.div(
  props => `
  height: 6rem;
  width: .1rem;
  background: ${props.theme.colors.ash.medium};
  position: absolute;
  left: 47%;
  z-index: -1;
  `,
);
